import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "userTransaction";

export const userTransactionService = {
    getAll
};

function getAll(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAll?${getQuery(query)}`, requestOptions).then(handleResponse);
}
